// Port of api/fuel/app/classes/filter/games.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var Games = Filter.extend({
	filter_type: F.TYPE_GAMES,
	cache_type: F.CACHE_GAMES,
	result_type: F.RESULT_GAME,
	pseudo_type: F.PSEUDO_GAME,
	json_package: 'games',
	package_types: [F.PACKAGE_GAME]
})

export default Games
